export const vrpcEthers = `import { VrpcProvider } from '@w3tech.io/vrpc-ethers';

const provider = new VrpcProvider('__url__');

// the SDK rejects any response whose signature does not check out
const blockNumber = await provider.getBlockNumber();
console.log(blockNumber);`;

export const vrpcViem = `import { createPublicClient } from 'viem';
import { vrpcHttp } from '@w3tech.io/vrpc-viem';

const client = createPublicClient({ transport: vrpcHttp('__url__') });

// the SDK rejects any response whose signature does not check out
const blockNumber = await client.getBlockNumber();
console.log(blockNumber);`;

export const vrpcCurl = `# bash: -i prints the vRPC-Signature, vRPC-Pubkey, vRPC-Timestamp and vRPC-NodeId headers
curl -i -X POST __url__ -H 'Content-Type: application/json' -d '{"jsonrpc":"2.0","method":"eth_blockNumber","params":[],"id":1}'`;
